import React, {FC} from 'react'
import {Link} from 'react-router-dom'
import clsx from 'clsx'
import {useLayout} from '../../core'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {AsideMenu} from './AsideMenu'
import ProjectSelector from './ProjectSelector'
import {useProjectSelection} from '../../../../app/modules/projectdetails/hooks/useProjectSelection'
import {DEMO_SECTIONS, getDemoSectionAttributes, isDemoSectionVisible} from '../../../../app/modules/demo/demoMode'

const AsideDefault: FC = () => {
  const {config, classes} = useLayout()
  const {aside} = config
  const {isPortfolio} = useProjectSelection()
  return (
    <div id='kt_aside' className={clsx('aside', classes.aside.join(' '))}
      data-kt-drawer='true' data-kt-drawer-name='aside' data-kt-drawer-activate='{default: true, lg: false}'
      data-kt-drawer-overlay='true' data-kt-drawer-width="{default:'200px', '300px': '250px'}"
      data-kt-drawer-direction='start' data-kt-drawer-toggle='#kt_aside_mobile_toggle'>
      <div className='aside-logo flex-column-auto border-bottom px-7 py-6' id='kt_aside_logo'>
        <Link to={isPortfolio ? '/portfolio-overview' : '/dashboard'} className='d-flex align-items-center gap-3'>
          <img alt='WebCert Logo' className='logo h-30px' src={toAbsoluteUrl('/media/logos/WebCert-logo.png')} />
        </Link>
        {aside.minimize && (
          <div id='kt_aside_toggle' className='btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle'
            data-kt-toggle='true' data-kt-toggle-state='active' data-kt-toggle-target='body' data-kt-toggle-name='aside-minimize'>
            <KTSVG path='/media/icons/duotune/arrows/arr079.svg' className='svg-icon-1 rotate-180' />
          </div>
        )}
      </div>
      {isDemoSectionVisible(DEMO_SECTIONS.ASIDE_PROJECT_SELECTOR) && (
        <div id='kt_aside_project' className='aside-project px-7 pt-4 pb-2'
          {...(getDemoSectionAttributes(DEMO_SECTIONS.ASIDE_PROJECT_SELECTOR) ?? {})}>
          <ProjectSelector />
        </div>
      )}
      {isDemoSectionVisible(DEMO_SECTIONS.ASIDE_PROJECT_SEPARATOR) && (
        <div className='menu-item' id='kt_aside_project_separator'
          {...(getDemoSectionAttributes(DEMO_SECTIONS.ASIDE_PROJECT_SEPARATOR) ?? {})}>
          <div className='menu-content px-7'>
            <div className='separator mx-0 my-2' />
          </div>
        </div>
      )}
      <div className='aside-menu flex-column-fluid'>
        <AsideMenu asideMenuCSSClasses={classes.asideMenu} />
      </div>
    </div>
  )
}

export {AsideDefault}
